export default {"src":"/_next/static/image/public/images/ic_video_off.7bfade662319f6d95c698e7ebeb7b87f.svg","height":56,"width":56};